import React from 'react';
import './orderonline.css';

function OrderOnline () {

    return (
        <section className="order-online">
            Order Online
        </section>
    )

}

export default OrderOnline;